// @flow

const asAbsolute = (...paths: string[]) => `/${paths.join("/")}`;

export {
	asAbsolute,
};
